import { createSlice } from "@reduxjs/toolkit";

export const ADD_DRIVER = "addDriver";
export const CURRENT_DRIVER_INDEX = "currentDriverIndex";

const initialState = {
  [ADD_DRIVER]: 1,
  drivers: [],
  [CURRENT_DRIVER_INDEX]: 0,
};

export const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    setAddDriver: (state, action) => {
      state[ADD_DRIVER] = action.payload[ADD_DRIVER];
    },
    addDriverData: (state, action) => {
      const { index, data } = action.payload;
      if (state.drivers[index]) {
        state.drivers[index] = { ...state.drivers[index], ...data };
      } else {
        state.drivers[index] = data;
      }
    },
    setDriverIndex: (state, action) => {
      state[CURRENT_DRIVER_INDEX] = action.payload.driverIndex;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAddDriver, addDriverData, setDriverIndex } =
  driverSlice.actions;

export const getDriverSliceData = (state, key) => {
  return state.driver[key];
};

export const getDriverDetails = (state, index) => {
  return state.driver.drivers[index];
};

export default driverSlice.reducer;
